module.exports = __webpack_public_path__ + "1792395595471/fonts/socicon.60e5857.eot";